import { Avatar } from 'antd';

/** Initials on a colour derived from the name, stable from one visit to the next. */
export function UserAvatar({ name, size = 34 }: { name: string; size?: number }) {
  const initials = name
    .split(/\s+/)
    .map((p) => p[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
  const palette = ['#0f766e', '#1d4ed8', '#7c3aed', '#b45309', '#be123c', '#0e7490', '#4d7c0f'];
  const hue = [...name].reduce((h, c) => h + c.charCodeAt(0), 0) % palette.length;
  return (
    <Avatar size={size} style={{ background: palette[hue], flexShrink: 0, fontSize: size * 0.4 }}>
      {initials}
    </Avatar>
  );
}
